import { Reducer } from "../../lib/redux";
import { IShipment } from "../../model/Shipment";
import { isIdEntity } from "../../utils/helpers";
import { ShipmentActions } from "./actions";
import { ShipmentActionTypes } from "./types";

export const defaultShipments: IIdDictionary<IIdDictionary<IShipment>> = {};

export const shipments: Reducer<IIdDictionary<IIdDictionary<IShipment>>, ShipmentActions> = (state = defaultShipments, action) => {
    switch (action.type) {
        case ShipmentActionTypes.SET_SHIPMENTS: {
            return {
                ...state,
                [action.payload.keyId]: action.payload.shipments
            };
        }
        case ShipmentActionTypes.CLEAR_USER_SHIPMENTS: {
            const newState: IIdDictionary<IIdDictionary<IShipment>> = {};
            for (const deviceId in state) {
                // for each device key, only keep the shipments that don't belong to the user we're clearing for
                const filteredDeviceLogs: IIdDictionary<IShipment> = {};
                for (const shipmentId in state[deviceId]) {
                    const shipment = state[deviceId][shipmentId];
                    if (isIdEntity(shipment.driver) && shipment.driver.id !== action.payload) {
                        filteredDeviceLogs[shipmentId] = shipment;
                    }
                }
                if (Object.keys(filteredDeviceLogs).length > 0) {
                    newState[deviceId] = filteredDeviceLogs;
                }
            }
            return newState;
        }
        case ShipmentActionTypes.CLEAR_DEVICE_SHIPMENTS: {
            let newState = { ...state };
            delete newState[action.payload];
            return newState;
        }
        case ShipmentActionTypes.CLEAR_ALL_SHIPMENTS:
            return {};
        default:
            return state;
    }
};